import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import toast from 'base/components/Toast/toast';
import { openModal } from 'modal/store/actions';
import { isSafari } from 'utils/browser';
import { getOfflineWaitingForSyncIds, getOfflineDocumentIds } from '../store/selectors';

class OnlineAppSync extends React.Component {
  componentDidMount() {
    const {
      openModal, waitingForSyncIds, offlineState, ids,
    } = this.props;
    if (ids.length > 0 && isSafari()) {
      toast.warn('Safari will only keep your offline documents \n'
          + 'for the next 7 days for data privacy reasons.');
    }
    if (waitingForSyncIds && waitingForSyncIds.length > 0) {
      openModal('OFFLINE_CHANGES_SYNC');
      // Use console to log to logrocket since we cannot pass custom objects otherwise
      console.log('Offline sync init', offlineState); // eslint-disable-line
    }
  }

  render() {
    return this.props.children || [];
  }
}

OnlineAppSync.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  openModal: PropTypes.func.isRequired,
  waitingForSyncIds: PropTypes.arrayOf(PropTypes.any),
  ids: PropTypes.arrayOf(PropTypes.any),
  offlineState: PropTypes.objectOf(PropTypes.any),
};
OnlineAppSync.defaultProps = {
  children: null,
  waitingForSyncIds: [],
  ids: [],
  offlineState: {},
};

const mapStateToProps = (state) => ({
  waitingForSyncIds: getOfflineWaitingForSyncIds(state),
  ids: getOfflineDocumentIds(state),
  offlineState: state.offline,
});
const mapDispatchToProps = {
  openModal,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OnlineAppSync);
